import { parse } from 'date-fns';
import { SequenceScheduleDaysModeEnum } from '../../../../../../store/rtk-query/apis/sequence/enums/sequence-schedule-mode.enum';

export const SCHEDULE_TIME_FORMAT = 'HH:mm';
const DEFAULT_SCHEDULE_TIME_HOUR = '10:32';

export const parseCampaignScheduleTime = (time: string): Date => {
  return parse(time, SCHEDULE_TIME_FORMAT, new Date());
};

export const DEFAULT_SCHEDULE_TIME = parseCampaignScheduleTime(DEFAULT_SCHEDULE_TIME_HOUR);
export const DEFAULT_SCHEDULE_DAYS_TYPE = SequenceScheduleDaysModeEnum.BusinessDays;
